import { render } from "./checkout_page.vue?vue&type=template&id=a5d5bbca"
import script from "./checkout_page.vue?vue&type=script&lang=js"
export * from "./checkout_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__